import { observer } from 'mobx-react-lite';
import { globalFiltersStore } from '../stores';
import React from 'react';
import { reaction } from 'mobx';

/**
 * Хук для работы с GlobalFiltersStore
 * @returns {GlobalFiltersStore} Экземпляр store
 */
export const useGlobalFilters = () => {
  return globalFiltersStore;
};

/**
 * Хук для получения только фильтров (без UI состояния)
 * @returns {Object} Объект с фильтрами
 */
export const useGlobalFiltersData = () => {
  return {
    filters: globalFiltersStore.filters,
    hasActiveFilters: globalFiltersStore.hasActiveFilters,
    filtersString: globalFiltersStore.filtersString
  };
};

/**
 * Хук для получения фильтров для API запросов
 * @returns {Object} Фильтры в формате для API
 */
export const useGlobalFiltersForAPI = () => {
  return globalFiltersStore.getFiltersForAPI();
};

/**
 * Хук для проверки валидности фильтров
 * @returns {Object} Объект с ошибками валидации
 */
export const useGlobalFiltersValidation = () => {
  return {
    errors: globalFiltersStore.getValidationErrors(),
    isValid: globalFiltersStore.getValidationErrors().length === 0,
    validateDateRange: globalFiltersStore.validateDateRange()
  };
};

/**
 * HOC для оборачивания компонентов в observer
 * @param {React.Component} Component - Компонент для оборачивания
 * @returns {React.Component} Обернутый компонент
 */
export const withGlobalFilters = (Component) => {
  return observer(Component);
};

/**
 * Хук для подписки на изменения фильтров
 * @param {Function} callback - Функция обратного вызова
 * @param {Array} dependencies - Зависимости для useEffect
 */
export const useGlobalFiltersSubscription = (callback, dependencies = []) => {
  const filtersStore = useGlobalFilters();
  
  React.useEffect(() => {
    // Создаем реакцию на изменения фильтров
    const disposer = reaction(
      () => filtersStore.filtersString,
      (filtersString) => {
        callback(filtersStore.filters);
      },
      { fireImmediately: true }
    );
    
    return disposer;
  }, [filtersStore, callback, ...dependencies]);
};
